import { arrayValidator, emailValidator } from '#validation/common/validators';
import { MAX_GUEST_LINK_EMAILS_BATCH } from '../constants';
export const guestLinkEmailValidator = emailValidator({
    requiredError: 'guestLink.email.required',
    formatError: 'guestLink.email.format',
});
export const guestLinkEmailsSchema = arrayValidator({
    element: guestLinkEmailValidator,
    maxLength: {
        max: MAX_GUEST_LINK_EMAILS_BATCH,
        error: 'guestLink.emails.maxLength',
    },
});
